
module.exports = require('./dist/post-robot');
module.exports.default = module.exports;
